import { RoutesConstant } from './routes.constant';

export const reportHeader = [
  {
    path: RoutesConstant.REPORT_GROUPS.JOB,
    text: 'header.tabs.report.job',
    value: 'job',
  },
  {
    path: RoutesConstant.REPORT_GROUPS.HR,
    text: 'header.tabs.report.hr',
    value: 'hr',
  },
  {
    path: RoutesConstant.REPORT_GROUPS.RECRUITER,
    text: 'header.tabs.report.recruiter',
    value: 'recruiter',
  },
  {
    path: RoutesConstant.REPORT_GROUPS.STATUS,
    text: 'header.tabs.report.status',
    value: 'status',
  },
  {
    path: RoutesConstant.REPORT_GROUPS.SOURCE,
    text: 'header.tabs.report.source',
    value: 'source',
  },
  {
    path: RoutesConstant.REPORT_GROUPS.REGION,
    text: 'header.tabs.report.region',
    value: 'region',
  },
  {
    path: RoutesConstant.REPORT_GROUPS.EXPERIENCE,
    text: 'header.tabs.report.experience',
    value: 'experience',
  },
];

export const chartVarieties = {
  DONUT: 'donut',
  BAR: 'bar',
  HORIZONTAL: 'horizontal',
};

export const NOT_ASSIGN_LABEL = 'Not assign';
